import CreateArea from "@/components/leaderGroup/CreateArea";
import { Grid } from "@mui/material";

export default function CreateTripPop({
  selectedProject,
  tripDigest,
  onClose,
  edit = false,
}) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Grid display="flex" width={"100%"}>
      <CreateArea
        selectedProject={selectedProject}
        tripDigest={tripDigest}
        onClose={handleClose}
        edit={edit}
      />
    </Grid>
  );
}
